import React, { useContext, useEffect, useState } from "react";
import { ConnectionContext, displayLoader, getAPITeam, getAPIImage} from "../utils";


const TeamLogo = (props) => {
    const { 
        teamId = null,
        defaultPictureId = null,
        fallback = null,
        ...restProps 
    } = props;

    const connectionInfo = useContext(ConnectionContext);
    const [ isLoaded, setLoaded ] = useState(false);
    const [ isFallback, setIsFallback ] = useState(false);
    const [ pictureId, setPictureId ] = useState(null);
    const [ logo, setLogo ] = useState(null);

    /**
     * Get the picture ID for the team
     */
    useEffect(()=> {
        if ( !connectionInfo ) return;

        setIsFallback(false);
        setLoaded(false);

        if ( defaultPictureId ) {
            setPictureId(defaultPictureId);
        } else if ( teamId ) {
            (async () => {
                try {
                    const result = await getAPITeam(teamId, connectionInfo);
                    if ( result && 'picture' in result ) {
                        setPictureId(result.picture);
                    } else {
                        setLoaded(true);
                    }
                } catch (err) {
                  console.error(err);
                }
            })();
        } else {
            setIsFallback(true);
        }
        
    }, [connectionInfo, defaultPictureId, teamId]);

    /**
     * When the picture ID is set, get the corresponding image from the API
     */
    useEffect(()=> {
        if ( !pictureId ) return;
        (async () => {
            try {
                const result = await getAPIImage(pictureId, connectionInfo);
                setLogo(result);
                setLoaded(true);
            } catch (err) {
              console.error(err);
            }
          })();
    }, [pictureId]);

    if ( !teamId && !defaultPictureId ) return fallback;


    // If we're loaded and there's no image, return our fallback
    if ( isFallback ) {
        return fallback;
    }

    return (
        <div className="teamLogo">
            { isLoaded ? (
                <img src={logo} className="teamLogo__inner" />
            ) : (
                displayLoader('acaLoader--fill')
            ) }
        </div>
    );

}

export { TeamLogo };

